import { formatDateForHash, getHashObj, getSasonBasedOnDate, parseHashParams } from "@/utils/utils";
import getFirstAvailableResponse from "@/vue/planning/logic/getFirstAvailableResponse"
import isHaveAvailability from "@/vue/planning/logic/isHaveAvailability"
import { AvailabilitiesResponse } from "@/types/responses";
import packConfig from "@/config/packConfig"
import store from "@/vue/planning/store/store"

const getHashPackCode = (): string | undefined => {
    const hash = window.location.hash.replace("#", "")
    const hashObj = getHashObj(hash) as {[key: string]: string}
    const hashPackCode: string | undefined = hashObj.packCode
    return hashPackCode
}

const ensureValidPackCodeIsSelected = (avail_resp: AvailabilitiesResponse, dispatch: any) => {
    const availablePackageCodeWiyp: { codePackage: string, prestId: string, maxPromo: number }[] = []

    avail_resp.availablePackages!.forEach(availablePackage => {
        availablePackageCodeWiyp.push({ codePackage: availablePackage.codePackage!, prestId: availablePackage.prestId! as string, maxPromo: 0 })
    });
    store.state.availablePackageCodeWiyp = availablePackageCodeWiyp;

    const hashPackCode: string | undefined = getHashPackCode()

    if(!hashPackCode || !availablePackageCodeWiyp.find(p => p.codePackage === hashPackCode)) {
        let wasPackageSet = false
        for(const priorityPackCode of packConfig) {
            if(availablePackageCodeWiyp.find(p => p.codePackage === priorityPackCode)) {
                dispatch("setPackage", priorityPackCode)
                wasPackageSet = true
                break
            }
        }
        if(!wasPackageSet) {
            dispatch("setPackage", avail_resp?.codePack) 
        }
    }
}

const makeInitialAvailRequest = async (store: any) => {
    const { state, commit, dispatch } = store

    const hashPackCode: string | undefined = getHashPackCode()
    let avail_resp = await getFirstAvailableResponse(store, hashPackCode)

    // Check if we need to switch season based on dates
    if (avail_resp?.endDates?.startDate) {
        const seasonBasedOnDate = getSasonBasedOnDate(avail_resp.endDates.startDate)

        if (seasonBasedOnDate !== state.season) {
            commit("setSeason", seasonBasedOnDate)
            window.seasonManager.switchSeasonWithoutReloading()
            avail_resp = await getFirstAvailableResponse(store, hashPackCode)
        }
    }

    // If still no availability - try switching seasons
    if (!isHaveAvailability(avail_resp)) {
        const newSeason = state.season === "E" ? "H" : "E"
        commit("setSeason", newSeason)
        window.seasonManager.switchSeasonWithoutReloading()

        // Try again with new season
        avail_resp = await getFirstAvailableResponse(store, hashPackCode)
        
        // If still no availability, try one more time with the original season
        if (!isHaveAvailability(avail_resp)) {
            commit("setSeason", state.season === "E" ? "H" : "E")
            window.seasonManager.switchSeasonWithoutReloading()
            avail_resp = await getFirstAvailableResponse(store, hashPackCode)
        }
    }

    if (!isHaveAvailability(avail_resp)) {
        commit("setProductUnavailable", true)
        dispatch("setLoading", false)
        return
    }

    // set packCode if it was empty, or it's not available
    ensureValidPackCodeIsSelected(avail_resp, dispatch)

    // set dates from response if url doesnt have them
    if (Object.keys(state.dates).length === 0) {
        const newDates = {
            "BeginDate": formatDateForHash(avail_resp?.endDates?.startDate),
            "EndDate": formatDateForHash(avail_resp?.endDates?.endDate),
        };
        dispatch("setDates", newDates)
    }

    return avail_resp
}

export default makeInitialAvailRequest